import { render } from "./CardsList.vue?vue&type=template&id=5b9420d2&ts=true"
import script from "./CardsList.vue?vue&type=script&lang=ts"
export * from "./CardsList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__